"use client";

import { Logo } from "@/components/logo";
import { Brand } from "@/types/general";
import { cn } from "@/utils/classnames";
import { Text } from "@stone-payments/jade";

type Props = {
  brand: Brand;
  className?: string;
};

export const LogoCatalog = ({ brand, className, ...rest }: Props) => {
  return (
    <div className={cn("flex flex-col items-center", className)} {...rest}>
      <div className="mb-1 flex items-center gap-1">
        <Logo brand={brand} />

        <Text className="h-3" variant="overline" color="medium">
          Catálogo
        </Text>
      </div>

      <Text variant="text-small" color="medium">
        Sua vitrine digital online.
      </Text>
    </div>
  );
};
